/*
  Theme-side hooks for the Style Guru and FitCore app embeds.
  The apps are used exactly as they ship:
    - Style Guru exposes window.StyleGuru.open(query) (loaded by its app embed).
    - FitCore renders a floating #fitcore-fab button; clicking it opens the size finder.
  Buttons marked [data-ls-app-hook] stay hidden until their app is on the page and open it on click.
  Elements marked [data-ls-app-show] only follow the app's presence (shown when loaded), with no
  click behaviour. Either way, a disabled embed never leaves a dead control behind.
*/
(() => {
  const APPS = {
    styleguru: {
      ready: () => typeof window.StyleGuru?.open === 'function',
      open: (button) => window.StyleGuru.open(queryFor(button)),
    },
    fitcore: {
      ready: () => Boolean(document.getElementById('fitcore-fab')),
      open: () => document.getElementById('fitcore-fab')?.click(),
    },
  };

  // Optional query: a fixed data-ls-query, or the current value of the input named in data-ls-query-from.
  function queryFor(button) {
    const source = button.dataset.lsQueryFrom && document.querySelector(button.dataset.lsQueryFrom);
    return (source?.value || button.dataset.lsQuery || '').trim();
  }

  function markReady() {
    let pending = false;
    document.querySelectorAll('[data-ls-app-hook]:not([data-ls-app-ready]), [data-ls-app-show]:not([data-ls-app-ready])').forEach((el) => {
      const app = APPS[el.dataset.lsAppHook || el.dataset.lsAppShow];
      if (app?.ready()) el.setAttribute('data-ls-app-ready', '');
      else pending = true;
    });
    document.documentElement.toggleAttribute('data-ls-styleguru', APPS.styleguru.ready());
    document.documentElement.toggleAttribute('data-ls-fitcore', APPS.fitcore.ready());
    return pending;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ls-app-hook][data-ls-app-ready]');
    if (!button) return;
    event.preventDefault();
    APPS[button.dataset.lsAppHook]?.open(button);
  });

  // App embeds load asynchronously; check for up to 15 seconds.
  let tries = 0;
  const poll = () => {
    if (markReady() && ++tries < 50) setTimeout(poll, 300);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poll);
  else poll();

  document.addEventListener('shopify:section:load', markReady);
})();
